import { render } from "./DeviceRegisterForm.vue?vue&type=template&id=62f32934"
import script from "./DeviceRegisterForm.vue?vue&type=script&lang=js"
export * from "./DeviceRegisterForm.vue?vue&type=script&lang=js"
script.render = render

export default script